import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { New, CacheService, INewBO } from '@mapfre-tech/amap3';
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class DaysNewsService {

   className = 'DaysNewsService'

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllNews(cache = true, cacheKey = "allNews"): Observable<INewBO[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<INewBO[]>;
       } else {
         const observable = this.http.get<INewBO[]>(environment.base_URL_GAIA + "/news").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newNew(newItem: INewBO) {
      return this.http.post(environment.base_URL_GAIA + "/new", newItem)
   }

   updateNew(editItem: INewBO, id: number) {
      return this.http.put(environment.base_URL_GAIA + `/new/${id}`, editItem)
   }

   deleteNew(id: number) {
      return this.http.delete(environment.base_URL_GAIA + `/new/${id}`)
   }

}
